import { createSlice, current } from '@reduxjs/toolkit'
import ORGANIZER_SLICE_CONST from './organizerSlice.const'
import setExhibitorsAc from './thunks/setExhibitorsAcThunk'

const organizerSlice = createSlice({
  name: 'organizer',
  initialState: ORGANIZER_SLICE_CONST.INITIAL_STATE,
  reducers: {
    setRegistrationByDayId: (state, action) => ({
      ...state,
      registrationByDayId: action.payload,
    }),
    setCurrentEntries: (state, action) => ({
      ...state,
      currentEntries: action.payload,
    }),
    resetExhibitorAc: (state) => {
      state.manageEvent.lists.exhibitors =
        ORGANIZER_SLICE_CONST.INITIAL_STATE.manageEvent.lists.exhibitors
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setExhibitorsAc.pending, (state) => {
        let exhibitorsState = current(state).manageEvent.lists.exhibitors
        state.manageEvent.lists.exhibitors.tabs[exhibitorsState.activeTab].status = 'loading'
      })
      .addCase(setExhibitorsAc.rejected, (state, action) => {
        let exhibitorsState = current(state).manageEvent.lists.exhibitors
        state.manageEvent.lists.exhibitors.tabs[exhibitorsState.activeTab].status = 'failed'
        state.manageEvent.lists.exhibitors.tabs[exhibitorsState.activeTab].message = (
          action.payload as any
        ).message
      })
      .addCase(setExhibitorsAc.fulfilled, (state, action) => {
        const { cursorId, query, filteredData, tabName } = action.payload

        let hasMore = false
        let exhibitorsState = current(state).manageEvent.lists.exhibitors
        let perPage = exhibitorsState.tabs[tabName].query.perPage
        let docsCountInDb = exhibitorsState.tabs[tabName].docsCountInDb
        let fetchedDocsCount = exhibitorsState.tabs[tabName].fetchedDocsCount

        if (fetchedDocsCount < perPage) {
          hasMore = false
        }

        if (!cursorId && action.payload.docsCountInDb) docsCountInDb = action.payload.docsCountInDb

        state.manageEvent.lists.exhibitors.tabs[tabName].data = cursorId
          ? [...state.manageEvent.lists.exhibitors.tabs[tabName].data, ...filteredData]
          : filteredData
        state.manageEvent.lists.exhibitors.tabs[tabName].temp = []
        state.manageEvent.lists.exhibitors.tabs[tabName].batch = []
        state.manageEvent.lists.exhibitors.tabs[tabName].message = null
        state.manageEvent.lists.exhibitors.tabs[tabName].hasMore = hasMore
        state.manageEvent.lists.exhibitors.tabs[tabName].status = 'fulfilled'
        state.manageEvent.lists.exhibitors.tabs[tabName].cursorId = cursorId
        state.manageEvent.lists.exhibitors.tabs[tabName].batchRunning = false
        state.manageEvent.lists.exhibitors.tabs[tabName].docsCountInDb = docsCountInDb
        state.manageEvent.lists.exhibitors.tabs[tabName].fetchedDocsCount = fetchedDocsCount
        state.manageEvent.lists.exhibitors.activeTab = tabName

        if (query) {
          state.manageEvent.lists.exhibitors.tabs[tabName] = {
            ...state.manageEvent.lists.exhibitors.tabs[tabName],
            query: {
              ...(state.manageEvent.lists.exhibitors.tabs[tabName].query ?? {}),
              ...query,
            },
          }
        }
      })
  },
})

const organizerSliceAcs = {
  setExhibitorsAc,
  ...organizerSlice.actions,
}

export { organizerSliceAcs }

export default organizerSlice.reducer
